import { gql } from "@apollo/client";

export const MISSION = gql`
    query queryMission($name: String!) {
        mission(name: $name) {
            id
            name
            start_date
            end_date
            city
            is_actived
        }
    }
`;

export const MISSIONS = gql`
    query queryMissions {
        missions {
            id
            name
            start_date
            end_date
            city
            is_actived
            is_deleted
        }
    }
`;

export default MISSIONS;
